(() => {
  'use strict';
  let shadowWatch;
  const rootWatch = new MutationObserver(prepare);
  const end = () => { rootWatch.disconnect(); shadowWatch?.disconnect(); };
  function prepare() {
    const host = document.querySelector('gty-whatsapp-chat-button');
    const shadow = host?.shadowRoot;
    if (!shadow) return;
    if (shadow.querySelector('#ph-whatsapp-mobile-ui')) { end(); return; }
    if (!shadow.querySelector('.gty-wacb-button')) {
      if (!shadowWatch) { shadowWatch = new MutationObserver(prepare); shadowWatch.observe(shadow, {childList: true, subtree: true}); }
      return;
    }
    const style = document.createElement('style');
    style.id = 'ph-whatsapp-mobile-ui';
    style.textContent = '@media(max-width:760px){.gty-wacb-wrapper{left:auto!important;right:14px!important;top:auto!important;bottom:calc(88px + env(safe-area-inset-bottom,0px))!important;z-index:90!important}.gty-wacb-button{width:48px!important;height:48px!important}.gty-wacb-button svg{width:26px!important;height:26px!important}}';
    shadow.appendChild(style);
    end();
  }
  prepare();
  if (!document.querySelector('gty-whatsapp-chat-button')?.shadowRoot?.querySelector('#ph-whatsapp-mobile-ui')) {
    rootWatch.observe(document.body, {childList: true, subtree: true});
    if (window.customElements) customElements.whenDefined('gty-whatsapp-chat-button').then(prepare);
    setTimeout(end, 30000);
  }
})();
